

export const getUsuarioStorage = () => {

    return {
        agente: localStorage.getItem('agente') || null,
        uidUsuario: localStorage.getItem('uidUsuario') || null,
        usuario: localStorage.getItem('usuario') || null,
        codigoEntidad: localStorage.getItem('codigoEntidad') || null,
        nombreEntidad: localStorage.getItem('nombreEntidad') || null,
        imagenLogo: localStorage.getItem('imagenLogo') || null,
        imagenIcono: localStorage.getItem('imagenIcono') || null,
        codigoUbicacion: localStorage.getItem('codigoUbicacion') || null,
        modulo: localStorage.getItem('modulo') || null,
        uidModulo: localStorage.getItem('uidModulo') || null,
        pantallas: localStorage.getItem('pantallas') || null,

    }
}